export default (() => {
    let io = null;

    const unobserve = el => {
        if (io && el) {
            io.unobserve(el);
        }
    };

    return {
        mounted(el, binding) {
            const { modifiers = {}, value = {} } = binding;
            const { enabled = true, callback, options = {} } = value;

            if (!enabled) return;

            io = new IntersectionObserver((entries, observer) => {
                const isIntersecting = entries.some(entry => entry.isIntersecting);

                if (typeof callback === 'function') {
                    callback(entries, observer, isIntersecting);
                }

                if (isIntersecting && modifiers.once) {
                    unobserve(el);
                }
            }, options);

            if (el) {
                io.observe(el);
            }
        },

        unmounted(el) {
            unobserve(el);
        },
    };
})();
